import { useMutation } from '@tanstack/react-query';
import type { MediaAsset } from '@wrapforce/shared';
import { workspacePath } from '@wrapforce/shared/api-client';
import { api } from '@/lib/api';

export function useUploadMedia(workspaceId: string | null) {
  return useMutation({
    mutationFn: async ({ file, kind, vehicleId, quoteId, jobId }: { file: File; kind: string; vehicleId?: string; quoteId?: string; jobId?: string }) => {
      const form = new FormData();
      form.append('file', file);
      form.append('kind', kind);
      if (vehicleId) form.append('vehicleId', vehicleId);
      if (quoteId) form.append('quoteId', quoteId);
      if (jobId) form.append('jobId', jobId);
      return api.upload<MediaAsset>(workspacePath(workspaceId!, '/media'), form);
    },
  });
}
